import { createContext, useEffect, useState } from "react";
import api from "./api";

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                // user context
                const usr = await api.request('GET', '/user', null, { silent: true });
                console.log('Fetched user:', usr);
                if (usr?.error) {
                    console.error(usr.error);
                    setUser(usr);
                } else {
                    if (usr.roles && usr.roles.includes('root')) {
                        usr.root = true;
                    }
                    setUser(usr);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    return (
        <UserContext.Provider value={{ user, loading }}>
            {children}
        </UserContext.Provider>
    );
}